export default {"src":"/_next/static/media/premium-experience.4fdfe3e4.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};